import { LinkButton, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface TermsAndConditionsBannerProps {
  onAcceptTerms: () => void;
  title?: string;
  message?: string;
  type?: "warning" | "danger";
}

export function TermsAndConditionsBanner({
  onAcceptTerms,
  title,
  message,
  type = "warning",
}: TermsAndConditionsBannerProps) {
  const { t } = useTranslation();

  const defaultTitle = t(
    "Please accept Certn's Terms and Conditions to continue."
  );
  const defaultMessage = t(
    "You must accept our updated terms and conditions to continue using your account."
  );

  return (
    <SectionMessage
      sectionTitle={title || defaultTitle}
      icon={type === "danger" ? "error" : "warning"}
      type={type}
    >
      {message || defaultMessage}{" "}
      <LinkButton
        linkStyle="monochrome"
        textStyle="global/body-secondary"
        onPress={onAcceptTerms}
        testID="terms-and-conditions-banner-link"
      >
        {t("Accept Terms")}
      </LinkButton>
    </SectionMessage>
  );
}
